<template>
  <div v-if="ad.AdImage" class="floating-ad">
    <img :src="ad.AdImage" @click="ad.JumpUrl && $util.jumpUrl(ad.JumpUrl)" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      ad: {}
    }
  },
  created() {
    if (process.client) {
      Promise.all([this.$request('homeLeftAd'), this.$request('getTime')]).then(
        ([data, timeRes]) => {
          if (data && data.AdImage && timeRes.time) {
            const nowTime = timeRes.time
            if (
              data.StartTime &&
              (this.$dayjs(nowTime).isAfter(this.$dayjs(data.StartTime)) ||
                this.$dayjs(nowTime).isSame(this.$dayjs(data.StartTime))) &&
              data.EndTime &&
              this.$dayjs(nowTime).isBefore(this.$dayjs(data.EndTime))
            ) {
              this.ad = data
              const countDown = this.$dayjs(data.EndTime).diff(
                this.$dayjs(nowTime)
              )
              setTimeout(() => {
                this.ad = {}
              }, countDown)
            }
          }
        }
      )
    }
  },
  methods: {}
}
</script>
